import type { Temporal } from '@js-temporal/polyfill'

/**
 * Formats a PlainTime for native HTML time input (HH:MM format)
 */
export function formatPlainTimeForNativeInput(
  time: Temporal.PlainTime,
): string {
  const hour = String(time.hour).padStart(2, '0')
  const minute = String(time.minute).padStart(2, '0')
  return `${hour}:${minute}`
}

/**
 * Resolves the time format (12 or 24 hour) based on hourCycle prop.
 */
export function resolveTimeFormat(hourCycle: 12 | 24): '12' | '24' {
  return hourCycle === 12 ? '12' : '24'
}

/**
 * Determines the effective step value based on granularity.
 * Returns 60 minutes for hour granularity, otherwise returns the provided step.
 */
export function getEffectiveStep(
  granularity: 'hour' | 'minute',
  step: number,
): number {
  if (granularity === 'hour') return 60
  return step
}
